import { useNavigate, useParams } from "react-router-dom";
import { useStore } from "../../../Components/StateProvider";
import { useEffect, useState } from "react";
import {
  getlocal,
  getStorage,
  setStorage,
} from "../../../functions/localstorage";
import {
  baseurl,
  ErrorAlert,
  getList,
  GetRecords,
  saveRecord,
  SuccessAlert,
  UpdateRecord,
  UploadFile,
  URLPRIFIX,
  WarningAlert,
} from "../../../functions/api";
import AccountsLayout from "../AccountsLayout";
import FormView from "../../../Components/Elements/FormView";
import { MdEdit, MdOutlineFileUpload } from "react-icons/md";
import { FaRegEye } from "react-icons/fa6";
import { HiOutlineArrowSmDown, HiOutlineArrowSmUp } from "react-icons/hi";
import { PrimaryBTN } from "../../../Constancs/cssconst";
import { FaArrowRight, FaEdit, FaPenNib, FaTruckLoading } from "react-icons/fa";
import { TiTick } from "react-icons/ti";
import { IoIosCloseCircleOutline } from "react-icons/io";

import {
  URL_Account_Charts_List,
  URL_Account_Client_Create,
  URL_Account_Client_Update,
  URL_Account_Customer_By_ID,
  URL_Account_Customer_Create,
  URL_Account_Customer_Update,
  URL_Account_Vendor_By_Id,
  URL_Account_Vendor_Create,
  URL_Account_Vendor_Update,
} from "../../../Constancs/apiconst";
import { emphasize } from "@mui/material";
import Select from "react-select";

function FormHeader({
  State = "New",
  FormName = "",
  FormNumber = "",
  Actions = [],
}) {
  return (
    <div className="flex items-center justify-between bg-secondary h-[38px] rounded-lg p-1 shadow-[0px_0px_10px_3px_rgba(0,0,0,0.1)] ">
      <div className="flex gap-3 h-full items-center">
        <span className=" text-[14px] border flex items-center px-1 py-0.5 rounded-lg">
          {State}
        </span>
        <span className="text-[14px]  flex flex-col">
          <span className="text-[12px] font-bold text-Ocean_Blue">
            {FormName}
          </span>
          <span className="text-[14px] font-semibold ">{FormNumber}</span>
        </span>
      </div>
      <div className="flex gap-3 h-full items-center mr-8">
        {Actions.map((item, index) => {
          if (item.visible)
            return (
              <button
                key={index}
                className={
                  "border px-2 py-1 rounded-lg font-semibold hover:bg-tertiary " +
                  (item.type === "primary"
                    ? " bg-Ocean_Blue text-secondary "
                    : " bg-Alice_Blue ")
                }
                onClick={item.onClick}
              >
                {item.ButtonName}
              </button>
            );
        })}
      </div>
    </div>
  );
}

function FormStage({ Stages = [] }) {
  return (
    <div className="flex items-center justify-center h-[38px] gap-3">
      {Stages.map((stage, index) => (
        <div key={index} className=" flex gap-1 items-center">
          <span
            className={
              " border p-1 rounded-full text-[14px] " +
              (stage.selected
                ? " bg-Ocean_Blue text-secondary "
                : stage.completed
                ? " bg-[#3ec95c] text-secondary "
                : " ")
            }
          >
            {stage.completed ? <TiTick /> : stage.icon}
          </span>
          <h3 className="text-[14px] pr-3">{stage.Name}</h3>
          {index < Stages.length - 1 ? <FaArrowRight /> : ""}
        </div>
      ))}
    </div>
  );
}

function TabsView({ tabsList = [], className = "" }) {
  const [tabs, settabs] = useState(0);
  return (
    <ul
      className={
        className +
        " flex flex-wrap text-sm font-medium text-center text-gray-500 border-b border-gray-200 dark:border-gray-700 dark:text-gray-400"
      }
    >
      <li className="me-2">
        {tabsList.map((tab, tabId) => (
          <button
            key={tabId}
            className={
              " p-2 text-primary  rounded-t-lg hover:bg-tertiary hover:text-primary " +
              (tabId === tabs
                ? " bg-Ocean_Blue text-secondary "
                : " bg-Alice_Blue ")
            }
            onClick={() => {
              tab.onClick && tab.onClick();
              settabs(tabId);
            }}
          >
            {tab.name}
          </button>
        ))}
      </li>
    </ul>
  );
}

const VendorForm = () => {
  const { companyId, option, id } = useParams();
  const navigate = useNavigate();
  // const getrecord = `/users/users/${id}`;
  const attachment_url_Prefix = "vendor_";
  const store = useStore();
  let storage = getStorage();
  var states = {
    India: [
      { value: "Andhra Pradesh", label: "Andhra Pradesh" },
      { value: "Arunachal Pradesh", label: "Arunachal Pradesh" },
      { value: "Assam", label: "Assam" },
      { value: "Bihar", label: "Bihar" },
      { value: "Chhattisgarh", label: "Chhattisgarh" },
      { value: "Goa", label: "Goa" },
      { value: "Gujarat", label: "Gujarat" },
      { value: "Haryana", label: "Haryana" },
      { value: "Himachal Pradesh", label: "Himachal Pradesh" },
      { value: "Jharkhand", label: "Jharkhand" },
      { value: "Karnataka", label: "Karnataka" },
      { value: "Kerala", label: "Kerala" },
      { value: "Madhya Pradesh", label: "Madhya Pradesh" },
      { value: "Maharashtra", label: "Maharashtra" },
      { value: "Manipur", label: "Manipur" },
      { value: "Meghalaya", label: "Meghalaya" },
      { value: "Mizoram", label: "Mizoram" },
      { value: "Nagaland", label: "Nagaland" },
      { value: "Odisha", label: "Odisha" },
      { value: "Punjab", label: "Punjab" },
      { value: "Rajasthan", label: "Rajasthan" },
      { value: "Sikkim", label: "Sikkim" },
      { value: "Tamil Nadu", label: "Tamil Nadu" },
      { value: "Telangana", label: "Telangana" },
      { value: "Tripura", label: "Tripura" },
      { value: "Uttar Pradesh", label: "Uttar Pradesh" },
      { value: "Uttarakhand", label: "Uttarakhand" },
      { value: "West Bengal", label: "West Bengal" },
    ],
    Malaysia: [
      { value: "Johor", label: "Johor" },
      { value: "Kedah", label: "Kedah" },
      { value: "Kelantan", label: "Kelantan" },
      { value: "Melaka", label: "Melaka" },
      { value: "Negeri Sembilan", label: "Negeri Sembilan" },
      { value: "Pahang", label: "Pahang" },
      { value: "Penang", label: "Penang" },
      { value: "Perak", label: "Perak" },
      { value: "Perlis", label: "Perlis" },
      { value: "Sabah", label: "Sabah" },
      { value: "Sarawak", label: "Sarawak" },
      { value: "Selangor", label: "Selangor" },
      { value: "Terengganu", label: "Terengganu" },
      { value: "Kuala Lumpur", label: "Kuala Lumpur (Federal Territory)" },
      { value: "Putrajaya", label: "Putrajaya (Federal Territory)" },
      { value: "Labuan", label: "Labuan (Federal Territory)" },
    ],
    "Sri Lanka": [
      { value: "Central", label: "Central Province" },
      { value: "Eastern", label: "Eastern Province" },
      { value: "Northern", label: "Northern Province" },
      { value: "North Central", label: "North Central Province" },
      { value: "North Western", label: "North Western Province" },
      { value: "Sabaragamuwa", label: "Sabaragamuwa Province" },
      { value: "Southern", label: "Southern Province" },
      { value: "Uva", label: "Uva Province" },
      { value: "Western", label: "Western Province" },
    ],
    "United Arab Emirates": [
      { value: "Abu Dhabi", label: "Abu Dhabi" },
      { value: "Dubai", label: "Dubai" },
      { value: "Sharjah", label: "Sharjah" },
      { value: "Ajman", label: "Ajman" },
      { value: "Fujairah", label: "Fujairah" },
      { value: "Ras Al Khaimah", label: "Ras Al Khaimah" },
      { value: "Umm Al Quwain", label: "Umm Al Quwain" },
    ],
    "United States of America": [
      { value: "Alabama", label: "Alabama" },
      { value: "Alaska", label: "Alaska" },
      { value: "Arizona", label: "Arizona" },
      { value: "Arkansas", label: "Arkansas" },
      { value: "California", label: "California" },
      { value: "Colorado", label: "Colorado" },
      { value: "Connecticut", label: "Connecticut" },
      { value: "Delaware", label: "Delaware" },
      { value: "Florida", label: "Florida" },
      { value: "Georgia", label: "Georgia" },
      { value: "Hawaii", label: "Hawaii" },
      { value: "Idaho", label: "Idaho" },
      { value: "Illinois", label: "Illinois" },
      { value: "Indiana", label: "Indiana" },
      { value: "Iowa", label: "Iowa" },
      { value: "Kansas", label: "Kansas" },
      { value: "Kentucky", label: "Kentucky" },
      { value: "Louisiana", label: "Louisiana" },
      { value: "Maine", label: "Maine" },
      { value: "Maryland", label: "Maryland" },
      { value: "Massachusetts", label: "Massachusetts" },
      { value: "Michigan", label: "Michigan" },
      { value: "Minnesota", label: "Minnesota" },
      { value: "Mississippi", label: "Mississippi" },
      { value: "Missouri", label: "Missouri" },
      { value: "Montana", label: "Montana" },
      { value: "Nebraska", label: "Nebraska" },
      { value: "Nevada", label: "Nevada" },
      { value: "New Hampshire", label: "New Hampshire" },
      { value: "New Jersey", label: "New Jersey" },
      { value: "New Mexico", label: "New Mexico" },
      { value: "New York", label: "New York" },
      { value: "North Carolina", label: "North Carolina" },
      { value: "North Dakota", label: "North Dakota" },
      { value: "Ohio", label: "Ohio" },
      { value: "Oklahoma", label: "Oklahoma" },
      { value: "Oregon", label: "Oregon" },
      { value: "Pennsylvania", label: "Pennsylvania" },
      { value: "Rhode Island", label: "Rhode Island" },
      { value: "South Carolina", label: "South Carolina" },
      { value: "South Dakota", label: "South Dakota" },
      { value: "Tennessee", label: "Tennessee" },
      { value: "Texas", label: "Texas" },
      { value: "Utah", label: "Utah" },
      { value: "Vermont", label: "Vermont" },
      { value: "Virginia", label: "Virginia" },
      { value: "Washington", label: "Washington" },
      { value: "West Virginia", label: "West Virginia" },
      { value: "Wisconsin", label: "Wisconsin" },
      { value: "Wyoming", label: "Wyoming" },
    ],
    Germany: [
      { value: "Baden-Württemberg", label: "Baden-Württemberg" },
      { value: "Bavaria", label: "Bavaria" },
      { value: "Berlin", label: "Berlin" },
      { value: "Brandenburg", label: "Brandenburg" },
      { value: "Bremen", label: "Bremen" },
      { value: "Hamburg", label: "Hamburg" },
      { value: "Hesse", label: "Hesse" },
      { value: "Lower Saxony", label: "Lower Saxony" },
      { value: "Mecklenburg-Vorpommern", label: "Mecklenburg-Vorpommern" },
      { value: "North Rhine-Westphalia", label: "North Rhine-Westphalia" },
      { value: "Rhineland-Palatinate", label: "Rhineland-Palatinate" },
      { value: "Saarland", label: "Saarland" },
      { value: "Saxony", label: "Saxony" },
      { value: "Saxony-Anhalt", label: "Saxony-Anhalt" },
      { value: "Schleswig-Holstein", label: "Schleswig-Holstein" },
      { value: "Thuringia", label: "Thuringia" },
    ],
    France: [
      { value: "Auvergne-Rhône-Alpes", label: "Auvergne-Rhône-Alpes" },
      { value: "Bourgogne-Franche-Comté", label: "Bourgogne-Franche-Comté" },
      { value: "Brittany", label: "Brittany" },
      { value: "Centre-Val de Loire", label: "Centre-Val de Loire" },
      { value: "Corsica", label: "Corsica" },
      { value: "Grand Est", label: "Grand Est" },
      { value: "Hauts-de-France", label: "Hauts-de-France" },
      { value: "Île-de-France", label: "Île-de-France" },
      { value: "Normandy", label: "Normandy" },
      { value: "Nouvelle-Aquitaine", label: "Nouvelle-Aquitaine" },
      { value: "Occitanie", label: "Occitanie" },
      { value: "Pays de la Loire", label: "Pays de la Loire" },
      {
        value: "Provence-Alpes-Côte d'Azur",
        label: "Provence-Alpes-Côte d'Azur",
      },
    ],
    Italy: [
      { value: "Abruzzo", label: "Abruzzo" },
      { value: "Aosta Valley", label: "Aosta Valley" },
      { value: "Apulia", label: "Apulia" },
      { value: "Basilicata", label: "Basilicata" },
      { value: "Calabria", label: "Calabria" },
      { value: "Campania", label: "Campania" },
      { value: "Emilia-Romagna", label: "Emilia-Romagna" },
      { value: "Friuli Venezia Giulia", label: "Friuli Venezia Giulia" },
      { value: "Lazio", label: "Lazio" },
      { value: "Liguria", label: "Liguria" },
      { value: "Lombardy", label: "Lombardy" },
      { value: "Marche", label: "Marche" },
      { value: "Molise", label: "Molise" },
      { value: "Piedmont", label: "Piedmont" },
      { value: "Sardinia", label: "Sardinia" },
      { value: "Sicily", label: "Sicily" },
      { value: "Trentino-Alto Adige", label: "Trentino-Alto Adige" },
      { value: "Tuscany", label: "Tuscany" },
      { value: "Umbria", label: "Umbria" },
      { value: "Veneto", label: "Veneto" },
    ],
    England: [
      { value: "East Midlands", label: "East Midlands" },
      { value: "East of England", label: "East of England" },
      { value: "London", label: "London" },
      { value: "North East", label: "North East" },
      { value: "North West", label: "North West" },
      { value: "South East", label: "South East" },
      { value: "South West", label: "South West" },
      { value: "West Midlands", label: "West Midlands" },
      { value: "Yorkshire and the Humber", label: "Yorkshire and the Humber" },
    ],
    Scotland: [
      { value: "Aberdeen City", label: "Aberdeen City" },
      { value: "Edinburgh", label: "Edinburgh" },
      { value: "Glasgow", label: "Glasgow" },
      { value: "Highland", label: "Highland" },
      // ... You can expand this with all 32 council areas if needed
    ],
    Wales: [
      { value: "Cardiff", label: "Cardiff" },
      { value: "Swansea", label: "Swansea" },
      { value: "Newport", label: "Newport" },
      // ... Other unitary authorities
    ],
    "Northern Ireland": [
      { value: "Belfast", label: "Belfast" },
      { value: "Derry and Strabane", label: "Derry and Strabane" },
      { value: "Lisburn and Castlereagh", label: "Lisburn and Castlereagh" },
      // ... Additional districts
    ],
  };
  // *initial values
  const init = {
    clientname: "",
    phoneno: "",
    email: "",
    payable_ledger_id: 0,
    gst_no: "",
    pan_no: "",
    tax_acc_no: "",
    attachment_url: [],
    account_no: "",
    account_holder_name: "",
    bank_name: "",
    branch: "",
    ifsc_code: "",
    // bank_address: "",
    address: [
      {
        name: "Permanent Address",
        line_1: "",
        line_2: "",
        state: "",
        country: "",
        pincode: "",
      },
    ],
    company_id: [],
  };
  const initProps = {
    add: false,
    delete: false,
    on_off: false,
    print: false,
    update: false,
    view: false,

    clientname: {},
    phoneno: {},
    email: {},
    payable_ledger_id: {
      payable_ledger_id_list: [{ label: "Please Choose", value: "" }],
    },
    gst_no: {},
    pan_no: {},
    tax_acc_no: {},
    account_no: {},
    account_holder_name: {},
    bank_name: {},
    company_id: {
      company_id_list: [{ label: "Please Choose", value: "" }],
    },
    attachment_url: {},
    branch: {},
    ifsc_code: {},
    // bank_address: {},
    address: {
      state_list: [{ value: "", label: "Please choose" }],
      countries_list: [
        { value: "", label: "Please choose" },
        { value: "India", label: "India" },

        { value: "Malaysia", label: "Malaysia" },
        { value: "Sri Lanka", label: "Sri Lanka" },
        { value: "United Arab Emirates", label: "United Arab Emirates" },
        {
          value: "United States of America",
          label: "United States of America",
        },
        { value: "Germany", label: "Germany" },
        { value: "France", label: "France" },
        { value: "Italy", label: "Italy" },
        { value: "England", label: "England" },
        { value: "Scotland", label: "Scotland" },
        { value: "Wales", label: "Wales" },
        { value: "Northern Ireland", label: "Northern Ireland" },
      ],
      addressmandatory: [],
    },
  };

  // *states declaration for records and props
  const [Record, setRecord] = useState(init);
  const [props, setprops] = useState(initProps);

  // *initial values set on the page load
  // *and change on dependencies of option and id changes
  useEffect(() => {
    console.log("id checking", id);

    const localprops = getlocal("properties")?.vendors || {};
    store.setmodule("vendors", init);
    store.stopLoading();
    // store.startLoading();

    HandleMultiPropsChange(localprops);
    // load list of records for  dropdown
    GetCompanyList();
    getPayableList();
    // change properties of fields
    HandleMultiPropsChange({
      clientname: { mandatory: true },
      company_id: { mandatory: true },
      email: { mandatory: true },
      address: { hidden: false },
      bank_name: { hidden: true },
      account_holder_name: { hidden: true },
      account_no: { hidden: true },
      ifsc_code: { hidden: true },
      branch: { hidden: true },
      // bank_address: { hidden: true },
      payable_ledger_id: { hidden: false, mandatory: false },
    });
    if (option === "view") {
      HandleMultiPropsChange({
        clientname: { readonly: true },
        phoneno: { readonly: true },
        email: { readonly: true },
        payable_ledger_id: { readonly: true },
        attachment_url: { readonly: true },
        pan_no: { readonly: true },
        tax_acc_no: { readonly: true },
        gst_no: { readonly: true },
        company_id: { readonly: true },

        account_no: { readonly: true },
        account_holder_name: { readonly: true },
        bank_name: { readonly: true },
        branch: { readonly: true },
        ifsc_code: { readonly: true },
        // bank_address: { readonly: true },
        address: { readonly: true },
      });
    } else {
      HandleMultiPropsChange({
        clientname: { readonly: false, mandatory: true },
        phoneno: { readonly: false, mandatory: true },
        email: { readonly: false, mandatory: true },
        payable_ledger_id: { readonly: false },
        attachment_url: { readonly: false },
        pan_no: { readonly: false },
        tax_acc_no: { readonly: false },
        gst_no: { readonly: false },
        company_id: { readonly: false },
        account_no: { readonly: false },
        account_holder_name: { readonly: false },
        bank_name: { readonly: false },
        branch: { readonly: false },
        ifsc_code: { readonly: false },
        address: { readonly: false },
      });
    }
    if (id != undefined) {
      console.log("edit working or not", id);
      GetRecords(URL_Account_Vendor_By_Id + id).then((res) => {
        if (res.success) {
          res = res.record;
          console.log("URL_Account_Vendor_By_Id", res);
          handleMultiFieldChange({
            clientname: res.clientname,
            company_id: res.company_id.map((item) => item.company_id),
            phoneno: res.phoneno,
            email: res.email,
            gst_no: res.gst_no,
            pan_no: res.pan_no,
            tax_acc_no: res.tax_acc_no,
            payable_ledger_id: res.payable_ledger_id,
            attachment_url: res.attachment_url,
            account_no: res.account_no,
            account_holder_name: res.account_holder_name,
            bank_name: res.bank_name,
            branch: res.branch,
            ifsc_code: res.ifsc_code,
            // bank_address: res.bank_address,
            address: JSON.parse(res.address) || [],
          });
          setSelectedOptions(
            res.company_id.map((item) => ({
              ...item,
              value: item.company_id,
              label: item.company_name,
            }))
          );
          let addressprops = JSON.parse(res?.address || "[]");
          let addresscheckmandatory = [...addressprops];
          addresscheckmandatory = addresscheckmandatory.map((item) => false);

          addressprops = addressprops.map((item) => {
            console.log("addressprops", item);
            return { value: item.state, label: item.state };
          });

          HandlePropsChange("address", {
            ...props.address,
            state_list: [...initProps.address.state_list, ...addressprops],
            addressmandatory: addresscheckmandatory,
          });
        }
      });
    } else {
    }
  }, [option, id]);

  //Load List of datas for dropdowns

  function getPayableList() {
    getList({
      listUrl: URL_Account_Charts_List + companyId,
      field: "group_id",
      search: "11",
      count: 1000,
    }).then((res) => {
      if (res.success) {
        res = res?.data?.list || [];
        res = res.map((item) => ({
          value: item.id,
          label: item.ledger_name,
        }));
        console.log("URL_Account_Charts_List Payable", res);
        HandlePropsChange("payable_ledger_id", {
          ...props.payable_ledger_id,
          payable_ledger_id_list: [
            ...initProps.payable_ledger_id.payable_ledger_id_list,
            ...res,
          ],
        });
      }
    });
  }

  function GetCompanyList() {
    getList({
      listUrl: "/api/v2/accountingcompany/getcompany/",
    }).then((res) => {
      if (res.success) {
        // console.log("1234",res?.data?.list);
        res = res?.data?.list || [];
        res = res.map((item) => ({
          value: item.id,
          label: item.company_name,
        }));
        HandlePropsChange("company_id", {
          company_id_list: [...initProps.company_id.company_id_list, ...res],
        });
      }
    });
  }

  // *print the Record and Props if any value change between the Record and Props
  useEffect(() => {
    console.log("Record State change -> ", Record);
    console.log("Props State change -> ", props);
  }, [Record, props]);

  const validateEmail = (email) => {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailRegex.test(email);
  };
  // *create Or update the Record
  function update() {
    store.startLoading();
    let savedata = { ...Record };
    const email = savedata.email;
    if (savedata.email && !validateEmail(email)) {
      store.stopLoading();
      ErrorAlert("Invalid email address. Please enter a valid email.");
      return;
    }
    savedata.modified_by = store.getuser().id;
    savedata.address = JSON.stringify(savedata.address);
    if (
      CheckForAddress() &&
      CheckMandatory() &&
      CheckforCompany() &&
      CheckForNumber()
    ) {
      UpdateRecord(URL_Account_Vendor_Update + id, savedata).then((res) => {
        console.log("Resonce of saveRecord - ", res);
        if (res.success) {
          store.stopLoading();
          SuccessAlert("Vendor Updated Successfully");
          store.navback();
        } else {
          console.log("errormessage", res);
          store.stopLoading();
          ErrorAlert(
            res?.errormessage?.data.message ||
              " Error Found Please contact the Admin"
          );
        }
      });
    }
  }
  function Submit() {
    store.startLoading();
    let savedata = { ...Record };
    const email = savedata.email;
    if (savedata.email && !validateEmail(email)) {
      store.stopLoading();
      ErrorAlert("Invalid email address. Please enter a valid email.");
      return;
    }
    savedata.modified_by = store.getuser().id;
    savedata.created_by = store.getuser().id;
    savedata.address = JSON.stringify(savedata.address);
    console.log("Submiting savedata", savedata);

    if (
      CheckForAddress() &&
      CheckMandatory() &&
      CheckforCompany() &&
      CheckForNumber()
    ) {
      saveRecord(URL_Account_Vendor_Create, savedata).then((res) => {
        console.log("Resonce of saveRecord - ", res);
        if (res.success) {
          store.stopLoading();
          SuccessAlert("Customer Submitted Successfully");
          store.navback();
        } else {
          store.stopLoading();
          ErrorAlert(
            res?.errormessage?.data.message ||
              " Error Found Please contact the Admin"
          );
        }
      });
    }
  }
  function HandleAttachement(event) {
    var bodyFormData = new FormData();
    bodyFormData.append("file", event.target.files[0]);
    let attachment_url = Record.attachment_url || [];
    UploadFile(attachment_url_Prefix, bodyFormData).then((res) => {
      if (res.success) {
        handleFieldChange("attachment_url", [...attachment_url, res.data]);
      }
    });
  }
  // *Check for the mandatory fields if empty or not
  function CheckMandatory() {
    let out = true;
    for (let obj in props) {
      if (typeof props[obj] === "object") {
        if (props[obj].mandatory) {
          if (Record[obj] == "" || Record[obj] == " ") {
            HandlePropsChange(obj, { mandatory: true, show: true });
            out = false;
          } else {
            HandlePropsChange(obj, { mandatory: true, show: false });
          }
        }
      }
    }
    out === false && ErrorAlert("Please fill the Mandatory Fields.");
    out === false && store.stopLoading();
    return out;
  }

  function CheckForAddress() {
    let addressprops = [...props.address.addressmandatory];
    let out = true;
    Record.address.map((address, addressId) => {
      if (
        address?.line_1 != undefined &&
        address?.line_1 != "" &&
        address?.state != undefined &&
        address?.state != "" &&
        address?.country != undefined &&
        address?.country != "" &&
        address?.pincode != undefined &&
        address?.pincode != ""
      ) {
        console.log("address Found");
        addressprops[addressId] = false;
      } else {
        console.log("address not found");
        addressprops[addressId] = true;
        out = false;
      }
    });
    HandlePropsChange("address", {
      ...props.address,
      addressmandatory: [...addressprops],
    });
    out === false && ErrorAlert("Please fill the Mandatory Address Fields.");
    out === false && store.stopLoading();
    return out;
  }

  function CheckforCompany() {
    console.log("CheckforCompany", Record.company_id.length > 0);

    if (Record.company_id.length > 0) {
      HandlePropsChange("company_id", { ...props.company_id, show: false });
      return true;
    } else {
      HandlePropsChange("company_id", { ...props.company_id, show: true });
      WarningAlert("Please fill the Mandatory Fields.");
      store.stopLoading();
      return false;
    }
  }

  function CheckForNumber() {
    let out = true;
    if (Record.phoneno.length < 8) {
      out = false;
      store.stopLoading();
      WarningAlert("Phone number need to have atlease 8 characters.");
      HandlePropsChange("phoneno", { mandatory: true, show: true });
    } else {
      HandlePropsChange("phoneno", { mandatory: true });
    }
    if (Record.gst_no == "") {
      return out;
    } else if (Record.gst_no.length > 15) {
      out = false;
      store.stopLoading();
      WarningAlert("GSt number need to have atlease 15 characters.");
      HandlePropsChange("gst_no", { show: true });
    } else {
      HandlePropsChange("gst_no", { show: false });
    }
    return out;
  }

  // *Handle Fields changes in Record States
  function handleFieldChange(fieldName, value) {
    setRecord((prev) => {
      return { ...prev, [fieldName]: value };
    });
  }
  function handleMultiFieldChange(value = {}) {
    setRecord((prev) => {
      for (let fieldName in value) {
        prev[fieldName] = value[fieldName];
      }
      return { ...prev };
    });
  }
  // *Handle Props Changes in Props States
  function HandlePropsChange(fieldName, value = {}) {
    setprops((prev) => {
      let oldprop = prev[fieldName];

      for (let prophead in value) {
        oldprop[prophead] = value[prophead];
      }
      prev[fieldName] = oldprop;
      return { ...prev };
    });
  }
  function HandleMultiPropsChange(NewProps = {}) {
    setprops((prev) => {
      for (let fieldName in NewProps) {
        let oldprop = prev[fieldName];
        let newprop = NewProps[fieldName];
        console.log("typeof newprop", typeof newprop);

        if (typeof newprop === "object") {
          for (let prophead in newprop) {
            oldprop[prophead] = newprop[prophead];
          }
          prev[fieldName] = oldprop;
        } else {
          prev[fieldName] = newprop;
        }
      }
      console.log("updated props", prev);

      return { ...prev };
    });
  }

  const [selectedOptions, setSelectedOptions] = useState([]);

  const handleChange = (selected) => {
    setSelectedOptions(selected);
    const selectedindexs = selected.map((option) => option.value);
    setRecord((prev) => ({
      ...prev,
      company_id: selectedindexs,
    }));
  };

  return (
    <div className="flex flex-col h-full text-[12px]">
      <FormHeader
        // State="Draft"
        FormName="Vendor"
        FormNumber={Record.clientname === "" ? "New Vendor" : Record.clientname}
        Actions={[
          {
            ButtonName: "Submit",
            type: "primary",
            onClick: Submit,
            visible: id === undefined,
          },
          {
            ButtonName: "Update",
            type: "primary",
            onClick: update,
            visible: option === "edit" && id !== undefined && props.update,
          },
          {
            ButtonName: "Edit",
            onClick: () => {
              navigate(
                `/${URLPRIFIX}/${companyId}/accounts/vendors/edit/${id}`,
                { replace: true }
              );
            },
            visible: option === "view" && id !== undefined && props.update,
          },
          {
            ButtonName: "Back",
            onClick: () => {
              navigate(-1);
            },
            visible: true,
          },
        ]}
      />
      {/* <FormStage Stages={props.Stages.Stages_list} /> */}
      <div className="flex bg-secondary flex-col items-center flex-grow rounded-lg shadow-[0px_0px_10px_3px_rgba(0,0,0,0.1)] overflow-auto">
        <div className="grid grid-cols-2 gap-2 w-[80%] mt-5">
          <div // clientname
            className={
              "text-[14px] w-full h-full px-3 flex-row items-center gap-3 " +
              (props.clientname.hidden ? " hidden " : " flex ")
            }
          >
            <label className={"w-fit  min-w-[150px] max-w-full"}>
              Vendor Name
              {props.clientname.mandatory && (
                <span className="text-[#ff2828] text-[14px] h-fit">*</span>
              )}
            </label>
            <input
              className={
                "w-full border-b border-Old_Silver border-opacity-35 px-2 py-1   text-black disabled:bg-[#c6c6ca] disabled:bg-opacity-20 outline-none " +
                (props.clientname.mandatory && props.clientname.show
                  ? " rounded-2xl border-2 border-[#ff2828] "
                  : "")
              }
              id={"clientname"}
              type="text"
              value={Record.clientname}
              disabled={props.clientname.readonly}
              onChange={(event) => {
                handleFieldChange("clientname", event.target.value);
              }}
            />
          </div>
          <div // email
            className={
              "text-[14px] w-full h-full px-3 flex-row items-center gap-3 " +
              (props.email.hidden ? " hidden " : " flex ")
            }
          >
            <label className={"w-fit  min-w-[150px] max-w-full"}>
              E-Mail Id
              {props.email.mandatory && (
                <span className="text-[#ff2828] text-[14px] h-fit">*</span>
              )}
            </label>
            <input
              className={
                "w-full border-b border-Old_Silver border-opacity-35 px-2 py-1   text-black disabled:bg-[#c6c6ca] disabled:bg-opacity-20 outline-none " +
                (props.email.mandatory && props.email.show
                  ? " rounded-2xl border-2 border-[#ff2828] "
                  : "")
              }
              id={"email"}
              type="text"
              value={Record.email}
              disabled={props.email.readonly}
              onChange={(event) => {
                handleFieldChange("email", event.target.value);
              }}
            />
          </div>
          <div // phoneno
            className={
              "text-[14px] w-full h-full px-3 flex-row items-center gap-3 " +
              (props.phoneno.hidden ? " hidden " : " flex ")
            }
          >
            <label className={"w-fit  min-w-[150px] max-w-full"}>
              Phone Number
              {props.phoneno.mandatory && (
                <span className="text-[#ff2828] text-[14px] h-fit">*</span>
              )}
            </label>
            <input
              className={
                "w-full border-b border-Old_Silver border-opacity-35 px-2 py-1   text-black disabled:bg-[#c6c6ca] disabled:bg-opacity-20 outline-none " +
                (props.phoneno.mandatory && props.phoneno.show
                  ? " rounded-2xl border-2 border-[#ff2828] "
                  : "")
              }
              id={"phoneno"}
              type="number"
              value={Record.phoneno}
              disabled={props.phoneno.readonly}
              onChange={(event) => {
                handleFieldChange("phoneno", event.target.value);
              }}
            />
          </div>
          <div // company
            className={
              "text-[14px] w-full h-full px-3 flex-row items-center gap-3 " +
              (props.company_id.hidden ? " hidden " : " flex ")
            }
          >
            <label className={"w-fit  min-w-[150px] max-w-full"}>
              Company
              {props.company_id.mandatory && (
                <span className="text-[#ff2828] text-[14px] h-fit">*</span>
              )}
            </label>
            <Select
              className={
                "w-full  " +
                (props.company_id.mandatory && props.company_id.show
                  ? " rounded-1xl border-2 border-[#6b6b6b] "
                  : "")
              }
              isMulti
              name="Company"
              options={props.company_id.company_id_list}
              value={selectedOptions}
              onChange={handleChange}
              isDisabled={props.company_id.readonly}
            />
          </div>
          <div // gst_no
            className={
              "text-[14px] w-full h-full px-3 flex-row items-center gap-3 " +
              (props.gst_no.hidden ? " hidden " : " flex ")
            }
          >
            <label className={"w-fit  min-w-[150px] max-w-full"}>
              GST Number
              {props.gst_no.mandatory && (
                <span className="text-[#1d1919] text-[14px] h-fit">*</span>
              )}
            </label>
            <input
              className={
                "w-full border-b border-Old_Silver border-opacity-35 px-2 py-1   text-black disabled:bg-[#c6c6ca] disabled:bg-opacity-20 outline-none " +
                (props.gst_no.mandatory && props.gst_no.show
                  ? " rounded-2xl border-2 border-[#ff2828] "
                  : "")
              }
              id={"gst_no"}
              type="text"
              value={Record.gst_no}
              disabled={props.gst_no.readonly}
              onChange={(event) => {
                handleFieldChange("gst_no", event.target.value);
              }}
            />
          </div>
          <div // pan no
            className={
              "text-[14px] w-full h-full px-3 flex-row items-center gap-3 " +
              (props.pan_no.hidden ? " hidden " : " flex ")
            }
          >
            <label className={"w-fit  min-w-[150px] max-w-full"}>
              PAN Number
              {props.pan_no.mandatory && (
                <span className="text-[#ff2828] text-[14px] h-fit">*</span>
              )}
            </label>
            <input
              className={
                "w-full border-b border-Old_Silver border-opacity-35 px-2 py-1   text-black disabled:bg-[#c6c6ca] disabled:bg-opacity-20 outline-none " +
                (props.pan_no.mandatory && props.pan_no.show
                  ? " rounded-2xl border-2 border-[#ff2828] "
                  : "")
              }
              id={"pan_no"}
              type="text"
              value={Record.pan_no}
              disabled={props.pan_no.readonly}
              onChange={(event) => {
                handleFieldChange("pan_no", event.target.value);
              }}
            />
          </div>
          <div // tax_acc_no
            className={
              "text-[14px] w-full h-full px-3 flex-row items-center gap-3 " +
              (props.tax_acc_no.hidden ? " hidden " : " flex ")
            }
          >
            <label className={"w-fit  min-w-[150px] max-w-full"}>
              TAN Number
              {props.tax_acc_no.mandatory && (
                <span className="text-[#ff2828] text-[14px] h-fit">*</span>
              )}
            </label>
            <input
              className={
                "w-full border-b border-Old_Silver border-opacity-35 px-2 py-1   text-black disabled:bg-[#c6c6ca] disabled:bg-opacity-20 outline-none " +
                (props.tax_acc_no.mandatory && props.tax_acc_no.show
                  ? " rounded-2xl border-2 border-[#ff2828] "
                  : "")
              }
              id={"tax_acc_no"}
              type="text"
              value={Record.tax_acc_no}
              disabled={props.tax_acc_no.readonly}
              onChange={(event) => {
                handleFieldChange("tax_acc_no", event.target.value);
              }}
            />
          </div>
          <div // payable_ledger_id
            className={
              "flex text-[14px] w-full h-full px-3 flex-row items-center gap-3 col-span-1 " +
              (props.payable_ledger_id.hidden ? " hidden " : " flex ")
            }
          >
            <label className={"w-fit  min-w-[150px] max-w-full"}>
              Account Payable
              {props.payable_ledger_id.mandatory && (
                <span className="text-[#ff2828] text-[14px] h-fit">*</span>
              )}
            </label>
            <select
              id={"payable_ledger_id"}
              onDragEnd={() => {
                console.log("At end arraived");
              }}
              className={
                " w-full border-b border-Old_Silver border-opacity-35 px-2 py-1   text-black disabled:bg-[#c6c6ca] disabled:bg-opacity-20   outline-none " +
                (props.payable_ledger_id.mandatory &&
                props.payable_ledger_id.show
                  ? " rounded-2xl border-2 border-[#ff2828] "
                  : "")
              }
              onChange={(event) => {
                handleFieldChange("payable_ledger_id", event.target.value);
              }}
              value={Record.payable_ledger_id}
              disabled={props.payable_ledger_id.readonly}
              aria-placeholder="please select sam"
            >
              {props.payable_ledger_id.payable_ledger_id_list.map(
                (item, index) => (
                  <option key={index} value={item.value}>
                    {item.label}
                  </option>
                )
              )}
            </select>
          </div>
          <div //attachment_url
            className="text-[14px] w-full h-full px-3 flex flex-col gap-2"
          >
            <div className="flex items-center gap-3">
              <label className="w-fit min-w-[150px] max-w-full">
                Attachments
              </label>
              {option !== "view" && (
                <button
                  className="border px-2 py-1 rounded-lg flex gap-1 items-center
                  hover:bg-Alice_Blue transition-all duration-150"
                  onClick={() => {
                    document.getElementById("FileInput").click();
                  }}
                >
                  <MdOutlineFileUpload className="text-[#20b25b] text-[18px] font-bold" />
                  Upload File
                </button>
              )}
            </div>
            <div className="flex flex-wrap gap-3">
              {Record?.attachment_url?.map((attached, index) => (
                <div
                  key={index}
                  className="cursor-pointer px-2 py-1 rounded-lg flex items-center gap-1 
                   hover:text-[#3f4fff] hover:bg-[#2a3cff] hover:bg-opacity-15
                   border border-gray-300 group transition-all duration-100"
                >
                  <span
                    onClick={() => {
                      store.navtotab(
                        baseurl + "/files/preview?key=" + attached
                      );
                    }}
                    className="text-[14px]"
                  >
                    {attached.replaceAll("vendor_/", "")}
                  </span>

                  <div className="flex items-center gap-1 opacity-0 group-hover:opacity-100 transition-opacity duration-150">
                    <IoIosCloseCircleOutline
                      className="text-red-500 hover:bg-[#FF0000]"
                      onClick={() => {
                        let attachment_url = Record.attachment_url || [];
                        attachment_url = attachment_url.filter(
                          (item, itemindex) => itemindex !== index
                        );
                        handleFieldChange("attachment_url", [
                          ...attachment_url,
                        ]);
                      }}
                    />
                  </div>
                </div>
              ))}
            </div>

            <input
              type="file"
              onChange={HandleAttachement}
              id="FileInput"
              className="hidden"
            />
          </div>
          <TabsView
            className="col-span-2 mt-1"
            tabsList={[
              {
                name: "Address",
                onClick: () => {
                  HandleMultiPropsChange({
                    address: { hidden: false },
                    bank_name: { hidden: true },
                    account_holder_name: { hidden: true },
                    account_no: { hidden: true },
                    ifsc_code: { hidden: true },
                    branch: { hidden: true },
                    // bank_address: { hidden: true },
                  });
                },
              },
              {
                name: "Bank",
                onClick: () => {
                  HandleMultiPropsChange({
                    address: { hidden: true },
                    bank_name: { hidden: false },
                    account_holder_name: { hidden: false },
                    account_no: { hidden: false },
                    ifsc_code: { hidden: false },
                    branch: { hidden: false },
                    // bank_address: { hidden: false },
                  });
                },
              },
            ]}
          />
          {/* address  */}
          {Record.address.map((address, addressId) => (
            <span
              className={
                "grid grid-cols-2 col-span-2 gap-3 " +
                (props?.address?.addressmandatory &&
                  props?.address?.addressmandatory[addressId] &&
                  " border-[#ff2828] border-2 ")
              }
            >
              <div
                className={
                  "col-span-2 flex items-center " +
                  (props.address.hidden ? " hidden " : " block ")
                }
              >
                <input
                  className="text-[18px]"
                  value={address.name}
                  onChange={(event) => {
                    let newaddress = Record.address;
                    newaddress[addressId].name = event.target.value;
                    handleFieldChange("address", newaddress);
                  }}
                />
                <FaEdit className="text-[18px] mr-1 opacity-25" />
                <hr className="flex-grow ml-3" />
                {option !== "view" && (
                  <button
                    className="hover:bg-Alice_Blue py-1 px-2 font-semibold text-[14px] border rounded-lg"
                    onClick={() => {
                      let newaddress = [...Record.address];
                      let addressprops = [...props.address.addressmandatory];
                      newaddress = newaddress.filter(
                        (item, index) => index != addressId
                      );
                      addressprops = addressprops.filter(
                        (item, index) => index != addressId
                      );
                      handleFieldChange("address", newaddress);
                      HandlePropsChange("address", {
                        ...props.address,
                        addressmandatory: addressprops,
                      });
                    }}
                  >
                    X
                  </button>
                )}
              </div>
              <div // address.Line_1
                className={
                  "text-[14px] w-full h-full px-3 flex-row items-center gap-3 " +
                  (props.address.hidden ? " hidden " : " flex ")
                }
              >
                <label className={"w-fit  min-w-[150px] max-w-full"}>
                  Address Line 1
                  {props.address.addressmandatory && (
                    <span className="text-[#ff2828] text-[14px] h-fit">*</span>
                  )}
                </label>
                <input
                  className={
                    "w-full border-b border-Old_Silver border-opacity-35 px-2 py-1   text-black disabled:bg-[#c6c6ca] disabled:bg-opacity-20 outline-none " +
                    (props.address.addressmandatory && props.address.show
                      ? " rounded-2xl border-2 border-[#ff2828] "
                      : "")
                  }
                  id={"address"}
                  type="text"
                  value={address.line_1}
                  disabled={props.address.readonly}
                  onChange={(event) => {
                    let newaddress = Record.address;
                    newaddress[addressId].line_1 = event.target.value;
                    handleFieldChange("address", newaddress);
                  }}
                />
              </div>
              <div // address.Line_2
                className={
                  "text-[14px] w-full h-full px-3 flex-row items-center gap-3 " +
                  (props.address.hidden ? " hidden " : " flex ")
                }
              >
                <label className={"w-fit  min-w-[150px] max-w-full"}>
                  Address Line 2
                  {/* {props.address.addressmandatory && (
                      <span className="text-[#ff2828] text-[14px] h-fit">
                        *
                      </span>
                    )} */}
                </label>
                <input
                  className={
                    "w-full border-b border-Old_Silver border-opacity-35 px-2 py-1   text-black disabled:bg-[#c6c6ca] disabled:bg-opacity-20 outline-none " +
                    (props.address.addressmandatory && props.address.show
                      ? " rounded-2xl border-2 border-[#ff2828] "
                      : "")
                  }
                  id={"address"}
                  type="text"
                  value={address.line_2}
                  disabled={props.address.readonly}
                  onChange={(event) => {
                    let newaddress = Record.address;
                    newaddress[addressId].line_2 = event.target.value;
                    handleFieldChange("address", newaddress);
                  }}
                />
              </div>
              <div // address.state
                className={
                  "flex text-[14px] w-full h-full px-3 flex-row items-center gap-3 " +
                  (props.address.hidden ? " hidden " : " flex ")
                }
              >
                <label className={"w-fit  min-w-[150px] max-w-full"}>
                  State
                  {props.address.addressmandatory && (
                    <span className="text-[#ff2828] text-[14px] h-fit">*</span>
                  )}
                </label>
                <select
                  id={"address"}
                  onDragEnd={() => {
                    console.log("At end arraived");
                  }}
                  className={
                    " w-full border-b border-Old_Silver border-opacity-35 px-2 py-1   text-black disabled:bg-[#c6c6ca] disabled:bg-opacity-20   outline-none " +
                    (props.address.addressmandatory && props.address.show
                      ? " rounded-2xl border-2 border-[#ff2828] "
                      : "")
                  }
                  onChange={(event) => {
                    let newaddress = Record.address;
                    newaddress[addressId].state = event.target.value;
                    handleFieldChange("address", newaddress);
                  }}
                  value={address.state}
                  disabled={props.address.readonly}
                  aria-placeholder="please select sam"
                >
                  {props.address.state_list.map((item, index) => (
                    <option key={index} value={item.value}>
                      {item.label}
                    </option>
                  ))}
                </select>
              </div>
              <div // address.country
                className={
                  "flex text-[14px] w-full h-full px-3 flex-row items-center gap-3 " +
                  (props.address.hidden ? " hidden " : " flex ")
                }
              >
                <label className={"w-fit  min-w-[150px] max-w-full"}>
                  Country
                  {props.address.addressmandatory && (
                    <span className="text-[#ff2828] text-[14px] h-fit">*</span>
                  )}
                </label>
                <select
                  id={"address"}
                  onDragEnd={() => {
                    console.log("At end arraived");
                  }}
                  className={
                    " w-full border-b border-Old_Silver border-opacity-35 px-2 py-1   text-black disabled:bg-[#c6c6ca] disabled:bg-opacity-20   outline-none " +
                    (props.address.addressmandatory && props.address.show
                      ? " rounded-2xl border-2 border-[#ff2828] "
                      : "")
                  }
                  onChange={(event) => {
                    let newaddress = Record.address;
                    newaddress[addressId].country = event.target.value;
                    handleFieldChange("address", newaddress);
                    HandlePropsChange("address", {
                      ...address,
                      state_list: [
                        ...initProps.address.state_list,
                        ...states[event.target.value],
                      ],
                    });
                  }}
                  value={address.country}
                  disabled={props.address.readonly}
                  aria-placeholder="please select sam"
                >
                  {props.address.countries_list.map((item, index) => (
                    <option key={index} value={item.value}>
                      {item.label}
                    </option>
                  ))}
                </select>
              </div>
              <div // address.pincode
                className={
                  "text-[14px] w-full h-full px-3 flex-row items-center gap-3 " +
                  (props.address.hidden ? " hidden " : " flex ")
                }
              >
                <label className={"w-fit  min-w-[150px] max-w-full"}>
                  Pincode
                  {props.address.addressmandatory && (
                    <span className="text-[#ff2828] text-[14px] h-fit">*</span>
                  )}
                </label>
                <input
                  className={
                    "w-full border-b border-Old_Silver border-opacity-35 px-2 py-1   text-black disabled:bg-[#c6c6ca] disabled:bg-opacity-20 outline-none " +
                    (props.address.addressmandatory && props.address.show
                      ? " rounded-2xl border-2 border-[#ff2828] "
                      : "")
                  }
                  id={"address"}
                  type="text"
                  value={address.pincode}
                  disabled={props.address.readonly}
                  onChange={(event) => {
                    let newaddress = Record.address;
                    newaddress[addressId].pincode = event.target.value;
                    handleFieldChange("address", newaddress);
                  }}
                />
              </div>
            </span>
          ))}
          {option !== "view" && (
            <div
              className={
                "col-span-2 " + (props.address.hidden ? " hidden " : " block ")
              }
            >
              <button
                className=" hover:bg-Ocean_Blue hover:text-secondary bg-Alice_Blue border p-2 rounded-lg"
                onClick={() => {
                  let newaddress = [...Record.address];
                  let newaddressProps = [...props.address.addressmandatory];
                  if (
                    newaddress.filter((item) => item.name === "other Address")
                      .length > 0
                  ) {
                    WarningAlert(
                      'Address with the same name "Other Address" is already exist. Please Change the Address header name'
                    );
                  } else {
                    if (newaddress.length == 1) {
                      newaddress.push({
                        name: "Delivery Address",
                        line_1: "",
                        line_2: "",
                        state: "",
                        country: "",
                        pincode: "",
                      });
                    } else if (newaddress.length == 0) {
                      newaddress.push({
                        name: "Permanent Address",
                        line_1: "",
                        line_2: "",
                        state: "",
                        country: "",
                        pincode: "",
                      });
                    } else {
                      newaddress.push({
                        name: "other Address",
                        line_1: "",
                        line_2: "",
                        state: "",
                        country: "",
                        pincode: "",
                      });
                    }
                    newaddressProps.push(false);
                    handleFieldChange("address", newaddress);
                    HandlePropsChange("address", {
                      ...props.address,
                      addressmandatory: [...newaddressProps],
                    });
                  }
                }}
              >
                Add Address
              </button>
            </div>
          )}

          <div // bank_name
            className={
              "text-[14px] w-full h-full px-3 flex-row items-center gap-3 " +
              (props.bank_name.hidden ? " hidden " : " flex ")
            }
          >
            <label className={"w-fit  min-w-[150px] max-w-full"}>
              Bank Name
              {props.bank_name.mandatory && (
                <span className="text-[#ff2828] text-[14px] h-fit">*</span>
              )}
            </label>
            <input
              className={
                "w-full border-b border-Old_Silver border-opacity-35 px-2 py-1   text-black disabled:bg-[#c6c6ca] disabled:bg-opacity-20 outline-none " +
                (props.bank_name.mandatory && props.bank_name.show
                  ? " rounded-2xl border-2 border-[#ff2828] "
                  : "")
              }
              id={"bank_name"}
              type="text"
              value={Record.bank_name}
              disabled={props.bank_name.readonly}
              onChange={(event) => {
                handleFieldChange("bank_name", event.target.value);
              }}
            />
          </div>
          <div // account_holder_name
            className={
              "text-[14px] w-full h-full px-3 flex-row items-center gap-3 " +
              (props.account_holder_name.hidden ? " hidden " : " flex ")
            }
          >
            <label className={"w-fit  min-w-[150px] max-w-full"}>
              Account Holder Name
              {props.account_holder_name.mandatory && (
                <span className="text-[#ff2828] text-[14px] h-fit">*</span>
              )}
            </label>
            <input
              className={
                "w-full border-b border-Old_Silver border-opacity-35 px-2 py-1   text-black disabled:bg-[#c6c6ca] disabled:bg-opacity-20 outline-none " +
                (props.account_holder_name.mandatory &&
                props.account_holder_name.show
                  ? " rounded-2xl border-2 border-[#ff2828] "
                  : "")
              }
              id={"account_holder_name"}
              type="text"
              value={Record.account_holder_name}
              disabled={props.account_holder_name.readonly}
              onChange={(event) => {
                handleFieldChange("account_holder_name", event.target.value);
              }}
            />
          </div>
          <div // account_no
            className={
              "text-[14px] w-full h-full px-3 flex-row items-center gap-3 " +
              (props.account_no.hidden ? " hidden " : " flex ")
            }
          >
            <label className={"w-fit  min-w-[150px] max-w-full"}>
              Account Number
              {props.account_no.mandatory && (
                <span className="text-[#ff2828] text-[14px] h-fit">*</span>
              )}
            </label>
            <input
              className={
                "w-full border-b border-Old_Silver border-opacity-35 px-2 py-1   text-black disabled:bg-[#c6c6ca] disabled:bg-opacity-20 outline-none " +
                (props.account_no.mandatory && props.account_no.show
                  ? " rounded-2xl border-2 border-[#ff2828] "
                  : "")
              }
              id={"account_no"}
              type="text"
              value={Record.account_no}
              disabled={props.account_no.readonly}
              onChange={(event) => {
                handleFieldChange("account_no", event.target.value);
              }}
            />
          </div>
          <div // ifsc_code
            className={
              "text-[14px] w-full h-full px-3 flex-row items-center gap-3 " +
              (props.ifsc_code.hidden ? " hidden " : " flex ")
            }
          >
            <label className={"w-fit  min-w-[150px] max-w-full"}>
              IFSC Code
              {props.ifsc_code.mandatory && (
                <span className="text-[#ff2828] text-[14px] h-fit">*</span>
              )}
            </label>
            <input
              className={
                "w-full border-b border-Old_Silver border-opacity-35 px-2 py-1   text-black disabled:bg-[#c6c6ca] disabled:bg-opacity-20 outline-none " +
                (props.ifsc_code.mandatory && props.ifsc_code.show
                  ? " rounded-2xl border-2 border-[#ff2828] "
                  : "")
              }
              id={"ifsc_code"}
              type="text"
              value={Record.ifsc_code}
              disabled={props.ifsc_code.readonly}
              onChange={(event) => {
                handleFieldChange("ifsc_code", event.target.value);
              }}
            />
          </div>
          <div // branch
            className={
              "text-[14px] w-full h-full px-3 flex-row items-center gap-3 " +
              (props.branch.hidden ? " hidden " : " flex ")
            }
          >
            <label className={"w-fit  min-w-[150px] max-w-full"}>
              Branch
              {props.branch.mandatory && (
                <span className="text-[#ff2828] text-[14px] h-fit">*</span>
              )}
            </label>
            <input
              className={
                "w-full border-b border-Old_Silver border-opacity-35 px-2 py-1   text-black disabled:bg-[#c6c6ca] disabled:bg-opacity-20 outline-none " +
                (props.branch.mandatory && props.branch.show
                  ? " rounded-2xl border-2 border-[#ff2828] "
                  : "")
              }
              id={"branch"}
              type="text"
              value={Record.branch}
              disabled={props.branch.readonly}
              onChange={(event) => {
                handleFieldChange("branch", event.target.value);
              }}
            />
          </div>
          {/* <div // bank_address
            className={
              "text-[14px] w-full h-full px-3 flex-row items-center gap-3 " +
              (props.bank_address.hidden ? " hidden " : " flex ")
            }
          >
            <label className={"w-fit  min-w-[150px] max-w-full"}>
              Bank Address
              {props.bank_address.mandatory && (
                <span className="text-[#ff2828] text-[14px] h-fit">*</span>
              )}
            </label>
            <input
              className={
                "w-full border-b border-Old_Silver border-opacity-35 px-2 py-1   text-black disabled:bg-[#c6c6ca] disabled:bg-opacity-20 outline-none " +
                (props.bank_address.mandatory && props.bank_address.show
                  ? " rounded-2xl border-2 border-[#ff2828] "
                  : "")
              }
              id={"bank_address"}
              type="text"
              value={Record.bank_address}
              disabled={props.bank_address.readonly}
              onChange={(event) => {
                handleFieldChange("bank_address", event.target.value);
              }}
            />
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default VendorForm;
